import { render } from "./Orgs.vue?vue&type=template&id=fbf69380&scoped=true"
import script from "./Orgs.vue?vue&type=script&lang=js"
export * from "./Orgs.vue?vue&type=script&lang=js"

import "./Orgs.vue?vue&type=style&index=0&id=fbf69380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf69380"]])

export default __exports__